<template>
    <section>
        <Header :title="organisation ? organisation.name : 'Activiteit aanvragen'" show-back-button></Header>
        <v-container>
            <v-row justify="center">
                <v-col cols="12" md="8" lg="6">
                    <h1 class="text-h5 mb-2">Activiteit aanvragen</h1>
                    <p v-if="organisation" class="mb-5">
                        Je vraagt een activiteit aan bij <strong>{{ organisation.name }}</strong>.
                    </p>
                    <p v-if="organisation && organisation.totalCosts" class="mb-5">
                        De kosten bedragen <strong>{{ formattedCosts }}</strong> per deelname (incl. btw).
                    </p>

                    <v-alert v-if="success" color="success">
                        Bedankt voor je aanvraag! Je ontvangt een bevestiging per e-mail. Zodra je
                        schoolbestuur de aanvraag heeft beoordeeld, hoor je daarover bericht.
                    </v-alert>

                    <v-form v-else ref="form" @submit.prevent="submit" :disabled="submitting">
                        <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                            label="Naam" v-model="form.name" :rules="[requiredRule]"
                        ></v-text-field>
                        <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                            label="Functie" v-model="form.function" :rules="[requiredRule]"
                        ></v-text-field>
                        <v-select outlined rounded required hide-details="auto" class="mb-4"
                            label="Schoolbestuur"
                            v-model="form.schoolbestuur"
                            :items="schoolbesturen"
                            item-text="name"
                            item-value="id"
                            :rules="[requiredRule]"
                            :loading="loadingSchoolbesturen"
                        ></v-select>
                        <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                            label="E-mail" v-model="form.email" :rules="[requiredRule, emailRule]"
                        ></v-text-field>
                        <v-textarea outlined rounded hide-details="auto" class="mb-4"
                            label="Motivatie (optioneel)" v-model="form.motivation" rows="3"
                        ></v-textarea>
                        <v-checkbox hide-details="auto" class="mt-0 mb-4"
                            label="Ik heb toestemming van mijn leidinggevende voor de aanvraag van deze dienst."
                            v-model="form.managerApproval" :rules="[managerApprovalRule]"
                        ></v-checkbox>
                        <v-btn type="submit" color="primary" rounded block :loading="submitting" :disabled="submitting" class="elevation-0">
                            Aanvraag versturen
                        </v-btn>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import Header from "@/components/layout/Header";
import {formatCosts} from "@/utils/formatters";

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
    name: "RequestForm",
    components: { Header },
    props: {
        uuid: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        organisation: null,
        schoolbesturen: [],
        loadingSchoolbesturen: true,
        submitting: false,
        success: false,
        form: {
            name: null,
            function: null,
            schoolbestuur: null,
            email: null,
            motivation: null,
            managerApproval: false,
        },
        requiredRule: (value) => !!value || "Dit veld is verplicht.",
        emailRule: (value) => !!(!value || value.match(emailRegex)) || "Ongeldig e-mailadres.",
        managerApprovalRule: (value) => value === true || "Toestemming van je leidinggevende is verplicht.",
    }),
    computed: {
        formattedCosts() {
            return formatCosts(this.organisation.totalCosts);
        },
    },
    mounted() {
        this.$store.dispatch('organisation/getOrganisation', this.uuid)
            .then(organisation => { this.organisation = organisation; })
            .catch(e => console.error(e));

        this.$store.dispatch('request/fetchSchoolbesturen')
            .then(schoolbesturen => { this.schoolbesturen = schoolbesturen; })
            .catch(e => {
                console.error(e);
                this.$store.dispatch('showSnackbar', { color: 'error', text: 'Schoolbesturen konden niet worden geladen' });
            })
            .finally(() => { this.loadingSchoolbesturen = false; });
    },
    methods: {
        submit() {
            if (!this.$refs.form.validate() || this.submitting) {
                return;
            }

            this.submitting = true;

            this.$store.dispatch('request/submitRequest', { uuid: this.uuid, data: this.form })
                .then(() => { this.success = true; })
                .catch(e => {
                    console.error(e);
                    this.$store.dispatch('showSnackbar', { color: 'error', text: 'Aanvraag kon niet worden verstuurd, controleer de invoer' });
                })
                .finally(() => { this.submitting = false; });
        },
    },
}
</script>
